<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="name" :field="field" :validator="validator"></EvoLabel>
            <Multiselect
                v-model="value"
                :options="optionsList()"
                :customLabel="customLabel"
                :name="name"
                :show-labels="false"
                :placeholder="field._placeholder"
                @input="otherDatasToSet"

            >

            </Multiselect>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";
import Multiselect from 'vue-multiselect'
import option_mixin from "./option_mixin";

export default {
    mixins: [mixin, option_mixin],
    components: {
        Multiselect
    },
    methods: {
        customLabel(option) {
            return _.find(this.field._options, ['_value', option])._display
        },
        optionsList() {
            return _.map(this.field._options, option => option._value)
        }
    }
}
</script>
